(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/drawer/assets/javascripts/drawer.js') >= 0) return;  svs.modules.push('/components/ui/drawer/assets/javascripts/drawer.js');

'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.ui = svs.ui || {};


svs.ui.Drawer = function () {
  function Drawer(options) {
    _classCallCheck(this, Drawer);
    var eventNotifier = new svs.core.Events(function () {});
    this.position = options.position || 'left';
    this.autoFold = options.autoFold || false;
    this.content = options.content;
    this.class = options.class;
    this.disableDimmerClick = (options === null || options === void 0 ? void 0 : options.disableDimmerClick) || false;
    this.isDimmerDisabled = options.isDimmerDisabled || false;
    this.id = new Date().getTime() + Math.floor(Math.random() * 9999);
    this.drawerId = "drawer-".concat(this.position, "-").concat(this.id);
    this.dimmerId = "drawer-dimmer-".concat(this.position, "-").concat(this.id);
    this.el = typeof options.el === 'string' ? document.querySelector(options.el) : options.el;
    this.dimmerEl = typeof options.el === 'string' ? document.querySelector(options.dimmerEl) : options.dimmerEl;
    this.body = document.body;
    this.on = eventNotifier.on;
    this.off = eventNotifier.off;
    this.trigger = eventNotifier.trigger;
    this.isSheet = options.isSheet || false;
    this.render();
    this.initEvents();
  }
  return _createClass(Drawer, [{
    key: "render",
    value: function render() {
      if (!this.dimmerEl && !this.isDimmerDisabled) {
        var dimmerHtml = svs.ui.drawer.partials.dimmer({
          autoFold: this.autoFold,
          id: this.dimmerId,
          isSheet: this.isSheet,
          position: this.position,
          disableDimmerClick: this.disableDimmerClick
        });
        this.body.insertAdjacentHTML('beforeend', dimmerHtml);
        this.dimmerEl = document.getElementById(this.dimmerId);
      }
      if (!this.el) {
        var drawerHtml = svs.ui.drawer.partials.drawer({
          autoFold: this.autoFold,
          class: this.class,
          content: this.content,
          id: this.drawerId,
          isSheet: this.isSheet,
          position: this.position
        });
        this.body.insertAdjacentHTML('beforeend', drawerHtml);
        this.el = document.getElementById(this.drawerId);
      }
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this = this;
      if (this.dimmerEl && !this.isDimmerDisabled && !this.disableDimmerClick) {
        this.dimmerEl.addEventListener('click', function () {
          _this.close();
        });
      }
    }
  }, {
    key: "showDimmer",
    value: function showDimmer() {
      this && this.dimmerEl && this.dimmerEl.classList.add("drawer-dimmer-position-".concat(this.position, "-open"));
    }
  }, {
    key: "hideDimmer",
    value: function hideDimmer() {
      this && this.dimmerEl && this.dimmerEl.classList.remove("drawer-dimmer-position-".concat(this.position, "-open"));
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;
      if (!this.el.classList.contains("drawer-position-".concat(this.position, "-open"))) {
        this.trigger('open');
        var animationEndEvent = function animationEndEvent() {
          _this2.el.removeEventListener('webkitAnimationEnd', animationEndEvent);
          _this2.el.removeEventListener('oAnimationend', animationEndEvent);
          _this2.el.removeEventListener('msAnimationEnd', animationEndEvent);
          _this2.el.removeEventListener('animationend', animationEndEvent);
          _this2.el.classList.remove("drawer-position-".concat(_this2.position, "-animate-open"));
          _this2.trigger('opened');
        };
        this.el.addEventListener('webkitAnimationEnd', animationEndEvent);
        this.el.addEventListener('oAnimationend', animationEndEvent);
        this.el.addEventListener('msAnimationEnd', animationEndEvent);
        this.el.addEventListener('animationend', animationEndEvent);
        this.el.classList.add("drawer-position-".concat(this.position, "-animate-open"));
        this.el.classList.add("drawer-position-".concat(this.position, "-open"));
        if (!this.isDimmerDisabled) {
          this.showDimmer();
        }
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;
      if (this.el.classList.contains("drawer-position-".concat(this.position, "-open"))) {
        this.trigger('close');
        var animationEndEvent = function animationEndEvent() {
          _this3.el.removeEventListener('webkitAnimationEnd', animationEndEvent);
          _this3.el.removeEventListener('oAnimationend', animationEndEvent);
          _this3.el.removeEventListener('msAnimationEnd', animationEndEvent);
          _this3.el.removeEventListener('animationend', animationEndEvent);
          _this3.el.classList.remove("drawer-position-".concat(_this3.position, "-animate-close"));
          _this3.trigger('closed');
        };
        this.el.addEventListener('webkitAnimationEnd', animationEndEvent);
        this.el.addEventListener('oAnimationend', animationEndEvent);
        this.el.addEventListener('msAnimationEnd', animationEndEvent);
        this.el.addEventListener('animationend', animationEndEvent);
        this.el.classList.add("drawer-position-".concat(this.position, "-animate-close"));
        this.el.classList.remove("drawer-position-".concat(this.position, "-open"));
        if (!this.isDimmerDisabled) {
          this.hideDimmer();
        }
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.el) {
        this.el.remove();
      }
      if (this.dimmerEl) {
        this.dimmerEl.remove();
      }
      this.trigger('remove');
    }
  }]);
}();

 })(window);